import {
  FETCH_REPORTINGS
} from './mutations-types'

export default {
  fetchReportings ({ commit }, payload) {
    // eslint-disable-next-line
    return axios({
      method: 'GET',
      url: 'http://localhost:8080/static/dummy-data/reportings.json'
    })
      .then(res => {
        commit(FETCH_REPORTINGS, res.data)
      })
  }
}
